import { imageUrl } from '@/vm/Shared/imageUrl';
import {
  StepWrapper,
  StepContent,
  StepDescription,
  StepContentNumber
} from './Step.styles';

type OwnProps = {
  imageFilename: string;
  labelOne: string;
  labelTwo?: string;
  number: string;
  position: 'left' | 'right';
};

export default function Step({
  imageFilename,
  labelOne,
  labelTwo,
  number,
  position
}: OwnProps) {
  return (
    <StepWrapper
      className={position === 'left' ? 'self-start' : 'self-end sm:self-start'}
    >
      <StepContent>
        <StepContentNumber>{number}</StepContentNumber>
        <div>
          <img
            src={imageUrl(imageFilename)}
            alt={`Step ${number}`}
            className="w-2/3"
          />
        </div>
      </StepContent>
      <StepDescription>
        <div>{labelOne}</div>
        <div>{labelTwo}</div>
      </StepDescription>
    </StepWrapper>
  );
}
